export class GetCUPCurPlanDetailInput{
    Years: string = ''
    DeptNo: string = ''
    TeamNo: string = ''
}